var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopupShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "share"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.3361 8.04381C22.4483 7.89301 22.6583 7.8667 22.7921 7.95983L22.7941 7.96178C25.6184 9.91618 27.4349 12.9917 27.8029 16.3837V16.454C27.7884 16.6059 27.6773 16.7305 27.5177 16.7596H27.4933C27.3542 16.7596 27.2175 16.6639 27.1691 16.5135L27.1544 16.4462C26.8096 13.2453 25.0798 10.3446 22.4191 8.50475C22.2708 8.39593 22.2353 8.19682 22.3361 8.04381Z",
    fill: "#3451F4",
    stroke: "#3451F4",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.2511 8.0117C9.40489 7.90315 9.61502 7.93989 9.72181 8.0908C9.8303 8.2445 9.7934 8.45467 9.6427 8.5615C7.00514 10.4191 5.30301 13.3266 4.97669 16.5322L4.97571 16.54V16.5478C4.96433 16.69 4.83009 16.8271 4.65345 16.8271H4.6056C4.42589 16.7937 4.30046 16.6273 4.31653 16.4531C4.65695 13.0619 6.45908 9.99437 9.25013 8.01072L9.2511 8.0117Z",
    fill: "#3451F4",
    stroke: "#3451F4",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.6198 27.7712C10.7088 27.598 10.9107 27.5385 11.0691 27.6198L11.073 27.6218C14.1386 29.1688 17.8232 29.1971 20.9157 27.7077L20.9187 27.7058C21.0745 27.6303 21.2781 27.6967 21.3601 27.865C21.4264 28.0013 21.3849 28.175 21.2605 28.2712L21.2028 28.3064C19.5873 29.0889 17.873 29.4802 16.0798 29.4802C14.2142 29.4802 12.4378 29.0532 10.7702 28.2204H10.7712C10.598 28.1315 10.5385 27.9296 10.6198 27.7712Z",
    fill: "#3451F4",
    stroke: "#3451F4",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.0804 2.50699C18.312 2.50719 20.1204 4.31534 20.1204 6.54703C20.1202 8.77733 18.2998 10.5869 16.0804 10.5871C13.8487 10.5871 12.0405 8.77867 12.0403 6.54703C12.0403 4.31522 13.8486 2.50699 16.0804 2.50699ZM16.0804 3.18668C14.2189 3.18668 12.7065 4.69833 12.7063 6.55973C12.7063 8.42125 14.2188 9.93375 16.0804 9.93375C17.9417 9.93355 19.4534 8.42113 19.4534 6.55973C19.4533 4.69632 17.9262 3.18688 16.0804 3.18668Z",
    fill: "#3451F4",
    stroke: "#3451F4",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M6.44 27.56C3.84 27.56 1.73333 25.4533 1.73333 22.8533C1.73333 20.2667 3.84 18.1467 6.44 18.1467C9.04 18.1467 11.1467 20.2533 11.1467 22.8533C11.1467 25.44 9.04 27.56 6.44 27.56ZM6.44 20.1467C4.94667 20.1467 3.73333 21.36 3.73333 22.8533C3.73333 24.3467 4.94667 25.56 6.44 25.56C7.93333 25.56 9.14667 24.3467 9.14667 22.8533C9.14667 21.36 7.93333 20.1467 6.44 20.1467Z",
    fill: "#3451F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M25.56 27.56C22.96 27.56 20.8533 25.4533 20.8533 22.8533C20.8533 20.2667 22.96 18.1467 25.56 18.1467C28.16 18.1467 30.2667 20.2533 30.2667 22.8533C30.2533 25.44 28.1467 27.56 25.56 27.56ZM25.56 20.1467C24.0667 20.1467 22.8533 21.36 22.8533 22.8533C22.8533 24.3467 24.0667 25.56 25.56 25.56C27.0533 25.56 28.2667 24.3467 28.2667 22.8533C28.2533 21.36 27.0533 20.1467 25.56 20.1467Z",
    fill: "#3451F4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_7",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupShare);
export default __webpack_public_path__ + "static/media/popup-share.2f723ebc6fcc5fcbdc0649c2f138d0ea.svg";
export { ForwardRef as ReactComponent };